import { DateTime } from 'luxon'

export const normalizeDate = (date: string) =>
  DateTime.fromISO(date).toLocaleString(DateTime.DATE_SHORT)
